import { Box, Chip, Typography, styled } from "@mui/material";

import { QUICK_FILTER } from "../constant";

const QuickChip = styled(Chip)(({ theme }) => ({
  borderRadius: 4,
  minWidth: 60,
  ".MuiChip-outlinedDefault": {
    borderColor: theme.palette.common.black,
    color: theme.palette.common.black,
  },
  ".MuiChip-filled": {
    border: `1px solid ${theme.palette.grey[400]}`,
    color: theme.palette.grey[700],
    backgroundColor: theme.palette.grey[200],
  },
}));

const QuickFilter = ({ onQuickFilter, state }) => {
  const handleSelect = (elem) => {
    onQuickFilter(elem);
  };

  return (
    <Box display={"flex"} sx={{ gap: 3 }}>
      <Typography sx={{ fontWeight: 600 }}>Quick filters:</Typography>
      {Object.entries(QUICK_FILTER).map(([label, value]) => (
        <QuickChip
          key={label}
          label={label}
          size="small"
          variant={state === value ? "outlined" : "filled"}
          onClick={() => handleSelect(value)}
        />
      ))}
    </Box>
  );
};

export default QuickFilter;
